<template>
    <div>
        <input-label v-if="label" :for_element="name">{{ $t(label) }}</input-label>

        <div class="relative">
            <input type="text"
                class="field w-full"
                :class="[ className, { 'read_only': read_only }]"
                :name="name"
                :value="value"
                @input="$emit('input', $event.target.value)"
                v-bind="$attrs"
                :readonly="read_only"
                :disabled="read_only"
            >

            <span class="absolute flex h-full items-center right-0 text-sm pr-3 top-0">
                %
            </span>
        </div>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,

    props: {
        label: {},
        name: {},
        className: {},
        value: {},
        read_only: { default: false },
    },
}
</script>

<style scoped>
    .read_only {
        background-color: #f7f7f7 !important;
        border-color: #f7f7f7 !important;
        color: #262626 !important;
    }

    .accordion .read_only {
        background-color: #fcfcfc !important;
    }

    .read_only::placeholder {
        color: transparent !important;
    }
</style>
